import { render, staticRenderFns } from "./PayPalModal.vue?vue&type=template&id=4914a8ee&scoped=true"
import script from "./PayPalModal.vue?vue&type=script&lang=js"
export * from "./PayPalModal.vue?vue&type=script&lang=js"
import style0 from "./PayPalModal.vue?vue&type=style&index=0&id=4914a8ee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4914a8ee",
  null
  
)

export default component.exports